import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageKeys } from '../enums/storage-keys.enum';
import { UrlKeys } from '../enums/urls.enum';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';

export const drCignaGuard: CanActivateFn = ():
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  return inject(AuthService).isLogged() && getDrCigna()
    ? true
    : inject(Router).createUrlTree([`/${UrlKeys.HOME}`]);
};

function getDrCigna(): boolean {
  const logData = inject(StorageService).sessionStorageGetItem(StorageKeys.LOGIN_DATA);
  let esVisible: boolean = false;
  if (logData.showPhemium) {
    esVisible = true;
  } else {
    if (Array.isArray(logData.authorized)) {
      for (const authorized of logData.authorized) {
        if (authorized.isAuthorized) {
          if (authorized.showPhemium) {
            esVisible = true;
          }
        }
      }
    }
  }
  return esVisible;
}
